<template>
	<div class="LoginService">
		<a-spin :spinning="spinning" tip="页面跳转中，请稍后~"></a-spin>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
// import URL from '@/store/url'
export default {
	name: 'LoginService',
  data() {
    return {
			spinning: false,
      errorNumber: 4,
    };
  },
	computed: {
    ...mapState(['isLogin', 'teacherAdmin', 'userInfo', 'loginFlag'])
  },
	created () {
		this.spinning = true
    let openids=JSON.parse(sessionStorage.getItem('wxuserInfo'))
    const unionid = openids.unionid
    const username = 'wdwqdqdqwdqdq'
     this.userLogin(username,unionid)
    
  },
	methods: {
		...mapMutations(['setGradesMaxMin']),
    ...mapActions(['getLogin_weixin', 'getUserInfo', 'getEndTime']),
		async userLogin(username, unionid) {
      try {
        await this.getLogin_weixin({ username: username, unionid: unionid }); // 登录

        if (this.isLogin == '联系平台客服解锁账号，或者等待1小时后解锁账号') {
          this.spinning = false
          this.$message.warning('联系平台客服解锁账号，或者等待1小时后解锁账号');
          return;
        }
        if (this.isLogin && this.teacherAdmin.tokenValue) {
          sessionStorage.setItem('teacherAdmin', JSON.stringify(this.teacherAdmin));
          await this.getUserInfo(); // 详细信息
          await this.getEndTime(); // 到期续费
          if (this.userInfo) {
						this.spinning = false
            this.$message.success('登录成功', 1);
						let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
						if (userInfo.max_grade && userInfo.min_grade) {
							// 判断是否设置年级范围
							let gradeList = [userInfo.min_grade, userInfo.max_grade];
							this.setGradesMaxMin(gradeList);
							sessionStorage.setItem('gradeMaxMin', JSON.stringify(gradeList));
							this.$router.push('/deskView');
						} else {
							this.$router.push('/initView');
						}
          } else {
						this.spinning = false
            this.$message.error('此账号没有权限~');
          }
        } else if (this.isLogin && !this.teacherAdmin.tokenValue) {
          this.spinning = false
          this.$message.error('登录失败');
        } else {
          this.spinning = false
          if (this.errorNumber == 0) {
            this.$message.warning(`联系平台客服解锁账号，或者等待1小时后解锁账号`);
          } else {
            this.$message.error(
              `您还有${this.errorNumber}次尝试登录的机会。请确保您输入的账号和密码无误再尝试登录！`
            );
          }
          this.errorNumber--;
        }
      } catch (e) {
        console.log(e);
        this.spinning = false
        this.$message.error('当前您的网络情况不佳，请刷新或稍后再试~');
      }
    }
	}
}
</script>

<style>
.LoginService {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	padding-top: 20%;
}
</style>
